import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';

function stopRowClick(event) {
  event.stopPropagation();
}

export function buildRoleColumns({ canUpdate, isDeleting, onDelete }) {
  return [
    {
      id: 'actions',
      header: '操作',
      size: 170,
      minSize: 150,
      enableSorting: false,
      enableResizing: false,
      meta: { enableColumnOrder: false, cellClassName: 'whitespace-nowrap' },
      cell: ({ row }) => (
        <div className="flex gap-2">
          <Button type="button" size="sm" variant="outline" asChild>
            <Link to={ROUTES.systemRoleEdit(row.original.id)} onClick={stopRowClick}>
              {canUpdate ? '編輯／權限' : '查看'}
            </Link>
          </Button>
          {canUpdate && row.original.code !== 'admin' ? (
            <Button
              type="button"
              size="sm"
              variant="destructive"
              disabled={isDeleting}
              onClick={(event) => {
                stopRowClick(event);
                onDelete(row.original);
              }}
            >
              刪除
            </Button>
          ) : null}
        </div>
      ),
    },
    {
      header: '代碼',
      accessorKey: 'code',
      size: 220,
      meta: { cellClassName: 'font-mono text-xs' },
      cell: ({ row }) => row.original.code || '—',
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 180,
      cell: ({ row }) => row.original.name || '—',
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 260,
      enableSorting: false,
      meta: { cellClassName: 'text-muted-foreground' },
      cell: ({ row }) => row.original.remark || '—',
    },
  ];
}
